import { render, staticRenderFns } from "./AppBarUserMenu.vue?vue&type=template&id=7f452d0a&scoped=true&"
import script from "./AppBarUserMenu.vue?vue&type=script&lang=js&"
export * from "./AppBarUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppBarUserMenu.vue?vue&type=style&index=0&id=7f452d0a&prod&lang=scss&"
import style1 from "./AppBarUserMenu.vue?vue&type=style&index=1&id=7f452d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f452d0a",
  null
  
)

export default component.exports